module.exports = __webpack_public_path__ + "img/dep2.bd85ad21.png";